(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.videoProductsQuickAddInitialized) {
    window.videoProductsQuickAddInitialized = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.video-quick-add-form');
      if (!form) return;

      event.preventDefault();

      const button = form.querySelector('[data-video-add-button]');
      const label = form.querySelector('[data-video-button-label]');
      const error = form.querySelector('[data-video-product-error]');
      if (!button || button.disabled) return;

      const defaultLabel = label ? label.textContent.trim() : '';
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
      if (label) label.textContent = 'Dodavanje…';
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      try {
        const formData = new FormData(form);
        const cart = document.querySelector('cart-drawer, cart-notification');

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Proizvod nije moguće dodati u korpu.');
        }

        if (cart && typeof cart.renderContents === 'function' && result.sections) {
          cart.renderContents(result);
          if (label) label.textContent = 'Dodano';
          window.setTimeout(() => {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            button.classList.remove('is-loading');
            if (label) label.textContent = defaultLabel;
          }, 1400);
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (caughtError) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
        if (label) label.textContent = defaultLabel;
        if (error) {
          error.textContent = caughtError.message || 'Proizvod nije moguće dodati u korpu.';
          error.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
